var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.$t('components.main.navigation.partner.with.us.airalo-for-corporates'),
      "back-button": {
        url: _vm.breadcrumbs[0].link,
        hiddenAfterSizes: 'sm'
      },
      "bordered": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "airalo-for-corporates-page my-20 my-md-30 my-lg-40 px-20 px-sm-30"
  }, [_c('breadcrumb', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbs
    }
  }), _vm._v(" "), _c('partner-with-us-contents', {
    attrs: {
      "contents": _vm.contents
    }
  }), _vm._v(" "), _c('airalo-affiliate-partners-have-to-say', {
    attrs: {
      "join-us-type": "corporate"
    }
  }), _vm._v(" "), _c('looking-for-more-custom')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }